import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { CLIENTS_DETAIL } from '../../constants/routes';

export default class ActualEnterprises extends Component {

  render () {
    const { regionsWithActualEnterprises } = this.props;

    return (
      <div className="actual-enterprises_wrapper">
        { regionsWithActualEnterprises.map((region, index) =>
          <div className="col-xs-12 panel  actual-enterprises_card panel-info" key={`region-` + index}>
            <div className="actual-enterprises_card__head panel-heading">
              <h4 className="actual-enterprises_card__head__title">{region.name}</h4>
            </div>

            <div className="actual-enterprises_card_body panel-body">
              { region.grains.map( (grain, index) =>
                <div className="actual-enterprises_card_body__group" key={`grain-` + index}>
                  <div className="actual-enterprises_card_body__group_title">
                    { grain.name }
                  </div>

                  { grain.enterprises.map( (enterprise, index) =>
                    <div className="actual-enterprises_card_body__group_row"  key={`enterprise-` + index}>
                      <div className="actual-enterprises_card_body__group_row__name">
                        <Link to={ CLIENTS_DETAIL + '?id=' + enterprise.id }>
                          <strong  className={"mr-bottom-20 btn-block"}>
                            { enterprise.name }
                          </strong>
                        </Link>
                      </div>
                      <div className="actual-enterprises_card_body__group_row__name">
                        { enterprise.address }
                      </div>
                      <div className="actual-enterprises_card_body__group_row__detail">
                        <div className="actual-enterprises_card_body__group_row__volume">
                          { enterprise.grainVolume }
                        </div>
                        <div className="actual-enterprises_card_body__group_row__detail-price">
                          { enterprise.grainPrice }
                        </div>
                        <div
                          className={`actual-enterprises_card_body__group_row__detail-date-from` + (enterprise.willExpireSoon ? ' highlight' : '')}>
                          { enterprise.lastCall }
                        </div>
                        <div
                          className={`actual-enterprises_card_body__group_row__detail-date-to` + (enterprise.willExpireSoon ? ' highlight' : '')}>
                          { enterprise.expirationContractDate }
                        </div>
                        <div className="actual-enterprises_card_body__group_row__detail-price">
                          { enterprise.managerName }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Search/ActualEnterprises.js